import { createMuiTheme } from "@material-ui/core";

export const createTheme = () => {
    return createMuiTheme({
      //shadows: Array(25).fill("none") as Shadows,
      typography: {
         fontFamily: 'Open Sans',
         body1: {
            fontSize: 12
         },
         h1: {
            fontWeight: 600,
            fontSize: 40
         },
         h2: {
            fontWeight: 300,
            fontSize: 24
         },
         h3: {
            fontWeight: 300,
            fontSize: 20
         },
         h4: {
            fontWeight: 300,
            fontSize: 17
         }
      },
      overrides: {
         MuiLink: {
				button: {
               color: "#2196f3",
				},
				underlineNone: {
					'&:hover': {
						color: '#2e9e9e'
					}
				}
			},
      },
      palette: {
         primary: {
            main: '#186ea8'
         },
         secondary: {
            main: '#2e9e9e'
         }
      }
    })
}